// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xsPid","col":"styles_col__1de4v","actions":"styles_actions__3e5l6","conflict":"styles_conflict__3w-Fn"};